import { createSelector } from 'reselect'
import { RootState } from '~/store'

export const GetMenuOpen = createSelector(
  [(state: RootState) => state.persistMenu.open],
  (open: boolean) => open
)
